// extracted by mini-css-extract-plugin
export var active = "NestedMenuEntry-module--active--5004a";
export var icon = "NestedMenuEntry-module--icon--d1ac0";
export var menuLink = "NestedMenuEntry-module--menuLink--39d58";
export var nestedEntries = "NestedMenuEntry-module--nestedEntries--82859";
export var nestedEntryOpen = "NestedMenuEntry-module--nestedEntryOpen--1a605";
export var nestedItem = "NestedMenuEntry-module--nestedItem--843cb";
export var subMenuDesktop = "NestedMenuEntry-module--subMenuDesktop--670a7";
export var subMenuWrapperDesktop = "NestedMenuEntry-module--subMenuWrapperDesktop--e9d66";
export var subMenuWrapperMobile = "NestedMenuEntry-module--subMenuWrapperMobile--3ffae";